/**
 * Lightweight Google Analytics 4 event helper.
 *
 * Usage:
 *   import { trackEvent } from "@/lib/analytics";
 *   trackEvent("generate_lead", { service: "Asbestos" });
 *
 * Safe to call on the server / before gtag.js has loaded — falls through to
 * window.dataLayer (gtag's queue), so the event is replayed once gtag.js is
 * ready. Dev mode also logs to the console for debugging.
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  try {
    // gtag.js queues events via dataLayer when invoked before the lib loads.
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    } else {
      window.dataLayer.push({ event: name, ...params });
    }
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.debug("[ga4]", name, params);
    }
  } catch (_e) { /* never let analytics break the UI */ }
}
